import React from 'react';
import { motion, useInView } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail } = FiIcons;

const SponsorCTA = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      className="section py-16 sm:py-20 md:py-24 relative"
      style={{ backgroundColor: 'var(--beige)' }}
      ref={ref}
    >
      {/* Heart Illustration */}
      <div className="absolute top-10 right-10 text-red-200 text-6xl sm:text-8xl opacity-30">
        ❤️
      </div>

      <div className="container px-4">
        <motion.div
          className="max-w-4xl mx-auto text-center"
          initial={{ y: 50, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold text-gray-900 mb-6 sm:mb-8">
            Partner With the Movement.
          </h2>

          <div className="prose prose-base sm:prose-xl text-gray-700 mb-8 sm:mb-10 max-w-none">
            <p className="mb-4 sm:mb-6">
              Boss At Heart is more than a podcast — it's a platform for purpose-driven brands and creators.
            </p>
            <p className="mb-4 sm:mb-6">
              If your brand stands for authenticity, community, and impact, we should talk.
            </p>
            <p>
              From sponsor features to creative collabs, let's build something that means something.
            </p>
          </div>

          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={isInView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <a
              href="mailto:camariacasher@yahoo.com"
              className="btn text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4"
            >
              <SafeIcon icon={FiMail} />
              Let's Collaborate
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default SponsorCTA;